import styles from './WorkflowDiagram.module.css';
import { WorkflowDiagramEntityStep } from './WorkflowDiagramEntityStep';
import { WorkflowDiagramConnectionStep } from './WorkflowDiagramConnectionStep';
import { IconName } from '../ui/Icon/Icon';

type WorkflowDiagramEntity = {
  type: 'entity';
  iconName: IconName;
  title: string;
  subtitle: string;
};

type WorkflowDiagramConnection = {
  type: 'connection';
  title: string;
};

type WorkflowDiagramProps = {
  steps: (WorkflowDiagramEntity | WorkflowDiagramConnection)[];
};

export const WorkflowDiagram = ({ steps }: WorkflowDiagramProps) => {
  return (
    <div className={styles.workflowDiagramLayout}>
      {steps.map((step, index) => {
        if (step.type === 'entity') {
          return (
            <WorkflowDiagramEntityStep
              key={index}
              iconName={step.iconName}
              title={step.title}
              subtitle={step.subtitle}
            />
          );
        } else if (step.type === 'connection') {
          return <WorkflowDiagramConnectionStep key={index} title={step.title} />;
        }
        return null;
      })}
    </div>
  );
};
